import { useRoute } from '@react-navigation/native';
import { WebviewScreenLayout } from 'shared/src/component';
import { useNavigationGoBack, useWebviewUri } from 'shared/src/hooks';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';

/** `/orders` 뒤에 딸려오는 쿼리 파라미터. 그대로 웹뷰 URL 로 승계한다. */
type OrderListRouteParams = Record<string, string | undefined>;

/**
 * 주문 내역 화면(내용은 웹뷰).
 *
 * 전용 화면으로 두는 이유는 Cart / OrderDetail 과 같다 — 범용 `WebViewScreen` 으로 열면
 * 목적지가 `url` params 문자열로 들어가 주소가 `/orders` 로 유지되지 않는다(뒤에 인코딩된
 * URL 이 붙는 형태). Navigator 에 `path` 로 등록해 주소를 유지한다.
 */
export const OrderListScreen = () => {
  const route = useRoute();
  const params = (route.params ?? {}) as OrderListRouteParams;
  const navigationGoBack = useNavigationGoBack();

  const uri = useWebviewUri(WEB_ROUTE_PATHS.OrderList, params);

  return (
    <WebviewScreenLayout
      title={'주문 · 예약 내역'}
      uri={uri}
      showHeader={true}
      onPressBack={navigationGoBack}
    />
  );
};
